import 'htmx.org'
import { initBarba } from './barba.js';

initBarba()